import { useReactiveSelectQuery } from "@/models/hooks/useReactiveSelectQuery";
import { myDriverUnreadCountQuery } from "@/models/repositories/Driver";

const COUNT_THROTTLE_MS = 750;

export function useMyDriverUnreadCount(workspaceId: string, membershipId: string | undefined, teamAliases: string[]) {
  const result =
    useReactiveSelectQuery(
      myDriverUnreadCountQuery,
      [{ workspaceId, membershipId: membershipId ?? "", teamAliases }],
      "DriverView:myDriverUnreadCountQuery",
      COUNT_THROTTLE_MS,
    ) ?? [];
  return result.length > 0 ? result[0].count : 0;
}
